
$(function () {
    //sets up the "View more" users button
    $(".company-details a.view-more").each(function (idx, element) {

        $(element).click(function () {
            $(element).siblings("table").addClass("expanded");
            $(element).siblings("a.view-less").css("display", "block");
            $(element).hide();
        });

    });

    //sets up the "View less" users button
    $(".company-details a.view-less").each(function (idx, element) {

        $(element).click(function () {
            $(element).siblings("table").removeClass("expanded");
            $(element).siblings("a.view-more").css("display", "block");
            $(element).hide();
        });

    });
});